//////////////////////////////////////////////
//! Debug function 
//////////////////////////////////////////////
var debug = function(message, alert){
	if (!alert) {
		alert = false;
	}
	if (app.settings.debug) {
		if (alert) {
			alert('DEBUG: '+message);
		} else {
			console.log('DEBUG: '+message);
		}
	}
};
//////////////////////////////////////////////
//////////////////////////////////////////////

app = {
//////////////////////////////////////////////
//! App Status settings
//////////////////////////////////////////////
	settings: {
		debug: false,
		
		//feature Site
		featureUrl: data.feature_site.url,
		
		//Page Animation
		pageSpeed: 300,
		
		//trailer (youtube)id
		showTrailer: data.trailer.show,
		trailerID: data.trailer.id,
		
		//overlay Speed(ms)
		overlaySpeed: 800,
		
		//Release Date Check
		releaseDate: data.release_date.system,
		filmReleased: false,
		
		//Credit slide tracking
		creditsOpen: false,
		
		//mobileMenu tracking
		menuOpen: false,
		
		//ShareMenu tracking
		shareOpen : false,
		socialOpen: false,
		
		//Quotes Slide speed(ms)
		quotsSpeed: 6000,
		
	},

//////////////////////////////////////////////
//! Dispatcher
//////////////////////////////////////////////
	dispatcher: new Dispatcher(),

//////////////////////////////////////////////
//! init Site
//////////////////////////////////////////////
	init:function(){
		
		audio.initSM();
		page.checkHash();//Check the hash
		ytPlayer.initYT();//Create the video player
		
		app.checkRelease();//Check the release date
		app.domEvents();//Activate dom element events
		
		
		//On touch devices...
		if(Modernizr.touch) {
			FastClick.attach(document.body);//Add fastclick
		}
	
	},

//////////////////////////////////////////////
//! Page Load Events
//////////////////////////////////////////////	
	pageEvents:function() { 
		//alert('Page Events');
		
		//CLose menu if open
		if(app.settings.menuOpen){ app.mobileMenu();}
		
		//if current page has not been viewd
		if (!page.viewed[page.current]) {
			
		}
		
		//Before page Specifics
				
		//Specific page first views
		
		//Home Page
		if ( page.current == 'home' && !page.viewed[page.current]) {
// 			app.sliderQuotes();
			app.creditsAutoSlide();
			app.quotesRotate();
		}
		
		else if ( page.current == 'home') {
// 			app.sliderReset('#js-quote-slider');
			parallax.addEvents();

		}
		
		//Gallery Page
		else if ( page.current === 'gallery' && !page.viewed[page.current] ) {
			app.sliderImageGallery();
		}
		
		else if ( page.current === 'gallery') {
			app.sliderReset('#js-gallery-slider');
		}
		
		//Videos Page
		else if ( page.current === 'videos' && !page.viewed[page.current] ) {
			app.sliderVideoGallery();
		}
		
		else if ( page.current === 'videos') {
			app.sliderReset('#js-video-slider');
		}
		
		//feature Page
		else if ( page.current === '208seconds' && !page.viewed[page.current] ) {
			audio.pause();
			$('#js-featuresite').attr('src', app.settings.featureUrl);
		}
		
		else if ( page.current === '208seconds') {
		
		}
		
		//do on every page load
	
	
		//By Page Audio Controls		
		
		//Turn Audio on under these circumstances
		if (Detectizr.device.type === 'desktop' && page.current !== '208seconds' && !audio.isPlaying && audio.userEnabled) {
			audio.play();
		}
		
		//Turn Audio off under these circumstances
		if (page.current === '208seconds' && audio.isPlaying) {
			audio.pause();
		}
	},

//////////////////////////////////////////////
//! DOM Element Events
//////////////////////////////////////////////
	domEvents:function(){
		
	//Page Change Events
		
		// On url Change
		$(window).hashchange(function(){page.checkHash(location.hash);});//..When the addressbar is updated
		
		
		
		//Open video
		
		
		//Close Video
		$('#js-overlayClose').click(function(e) { e.preventDefault(); ytPlayer.hide();
		});
		
		//Trailer buttons
		$('.js-trailerOpen').click(function(e) { e.preventDefault(); ytPlayer.show('trailer');
		});
		
		
		//Soundtrack
		$('#js-audioBtn').click(function(e) { e.preventDefault(); audio.userToggle();
		});
		
		//Credits
		$('.js-creditsToggle').click(function(e) { e.preventDefault(); app.creditManualSlide();
		});
		
		//Popup Windows
		$('.js-popup').click(function(e) { e.preventDefault();
			
			app.popupWindows(
				$(this).attr('href'), //Url
				$(this).attr('data-name'), //Name
				$(this).attr('data-size') //Size
			);
		});
		
		//Mouse out for desktop(no touch only)
		$('#js-creditSlide').mouseleave(function() { 
			
			if (app.settings.creditsOpen && !Modernizr.touch) {
				
				app.creditManualSlide();
			}
		});
		
		//Click on touch device(touch only)
		$('#js-creditSlide').click(function(e) { 
			
			if (app.settings.creditsOpen && Modernizr.touch) {
				
				app.creditManualSlide();
			}
		});
		
		//Share Menu
		$('#js-shareToggle').click(function(e){ e.preventDefault(); app.shareToggle();});
		
		//Mouse out for desktop(no touch only)
		$('.site-footer').mouseleave(function() { 
			
			if (app.settings.shareOpen && !Modernizr.touch) {
				
				app.shareToggle();
			}
		});
		
		
		
		//Click page on touch devices to hide credits and share 
		if(Detectizr.device.type != "desktop"){
			
			$('.page').click(function(e){
				
				if(app.settings.creditsOpen) app.creditManualSlide();
				if(app.settings.shareOpen) app.shareToggle();

			});
		}
		
		//Socialmenu for tablets
		$('#js-social-linksToggle').click(function(e){ e.preventDefault();
			app.socialToggle();
			
		});
		
		//Mobile Main menu
		$('#js-menuToggle').click(function(e){ e.preventDefault(); app.mobileMenu(); });
		
		//Click branding to go home
		$('.main-menu__branding').click(function(e){ e.preventDefault();
			page.checkUrl('home'); 
		});
		
		
		
	},

//////////////////////////////////////////////
//! Window Resize Events
//////////////////////////////////////////////	
	resizeEvents:function(){
		
		// Stop the menu being open if screen resized to larger sizes 
		// where the toggle button is no longer vis
		
		if (Detectizr.device.type !== 'mobile') {
			if(app.settings.menuOpen){ app.mobileMenu();}
		}

		
		//Page based resize events
		
		//Gallery page
		if ( page.current === 'gallery') {
			app.sliderReslick('#js-gallery-slider', 768, app.sliderImageGallery.settings);
			
		}
		
		if ( page.current === 'videos') {
			app.sliderReslick('#js-video-slider', 768, app.sliderVideoGallery.settings);
		}
		
		if (app.settings.shareOpen) {
			app.shareToggle();
		}
		
		if (app.settings.socialOpen) {
			app.socialToggle();
		}
		
	},

//////////////////////////////////////////////
//! Window.fous/blur events
//////////////////////////////////////////////
	focusEvents:function() {
		
		if(!audio.isPlaying && audio.userEnabled && !ytPlayer.isOpen && page.current !== '208seconds') {
			
			audio.play();
			
		}

		if (ytPlayer.isOpen && Detectizr.device.type == "desktop") {
			
			ytPlayer.video.play();
		}
		
	},
	
	blurEvents:function(){
		
		if(audio.isPlaying) {
			
			audio.pause();
			
		}

		if ( ytPlayer.isOpen && Detectizr.device.type == "desktop") {
			
			ytPlayer.video.pause()
		}
		
	},

//////////////////////////////////////////////
//! Menu Systems
//////////////////////////////////////////////

	// Open Close the main menu on mobile devices
	mobileMenu: function() {
		
		app.cssToggleOpen('#js-menuPanal');
		app.cssToggleOpen('#js-menuToggle');
		
		if(!app.settings.menuOpen) {
			
			app.settings.menuOpen = true;
			app.lockPageScroll(true);
		} 
		
		else {
			
			app.settings.menuOpen = false;
			app.lockPageScroll(false);
		}
	},
	
	//Open close the sahring menu
	shareToggle:function() {
		app.cssToggleOpen('#js-shareMenu');
		app.cssToggleOpen('#js-shareToggle');
		if(!app.settings.shareOpen) {
			
			app.settings.shareOpen = true;
		} 
		
		else {
			
			app.settings.shareOpen = false;
		}
	},
	
	socialToggle: function(){
		app.cssToggleOpen('#js-socialSlide');
		if(!app.settings.socialOpen) {
			
			app.settings.socialOpen = true;
		} 
		
		else {
			
			app.settings.socialOpen = false;
		}
		
	},
	
	//Credits Automatic Open Close
	creditsAutoSlide: function() {
		app.cssToggleOpen('#js-creditSlide');
			setTimeout(function(){
				app.cssToggleOpen('#js-creditSlide');
			}, 5000);
	},
	
	//Credits Manual open close
	creditManualSlide: function(){
		app.cssToggleOpen('#js-creditSlide');
		
		if(!app.settings.creditsOpen) {
			
			app.settings.creditsOpen = true;
		} 
		
		else {
			
			app.settings.creditsOpen = false;
		}
	},

//////////////////////////////////////////////
//! General Site Functions + utilities
//////////////////////////////////////////////
	
	//Check the release date of the film
	checkRelease:function() {
		var today = new Date(),
			 release = new Date(app.settings.releaseDate)
		;

		if ( release <= today ) {
			
			$('body').addClass('film-is-released');
			$('.js-prerelease').remove();
		}
		
		else {	
			
			$('body').addClass('film-not-released');
			$('.js-postrelease').remove();
		}
	},
	
	//Lock Unlock Page Scrolling
	lockPageScroll: function(state) {
		
		if (state === true ) {
			$(".viewport").addClass("is-locked");
		} else if (state === false ) {
			$(".viewport").removeClass("is-locked");
		} else {
			$(".viewport").toggleClass("is-locked");
		}
	},
	
	//Toggle CSS is-open/is-close states
	cssToggleOpen: function(target) {
		$(target).toggleClass('is-open is-close');
	},
	
	//Pop Up window controller
	popupWindows:function(url, name, windowSize) {
		//alert(url+', '+width+', '+height);
		
		
		newwindow=window.open(url, name, windowSize);
		if (window.focus) {newwindow.focus();}
			return false;
	},
	
	removeSubPx:function(element, attribute) {
		val = $(element).css(attribute).replace(/[^-\d\.]/g, '');
		newVal = Math.floor(val);
		
		
		
		$(element).css(attribute, Math.floor(val));
		
		console.log(element + ' ' + attribute + ' from: ' + val + ' to: '+ newVal);
	},
	
	quotesRotate:function(target){
		
		function noHover() {
			return this.is(':hover') ? this.wait('mouseleave') : this;
		}
		
		if($('#js-QuotesRotate > blockquote').length > 1) {
		
			$('#js-QuotesRotate > blockquote').hide().repeat().each($).fadeIn($).wait(app.settings.quotsSpeed).wait(noHover).fadeOut($);
		} else {
			
			$('#js-QuotesRotate > blockquote').fadeIn($);
		}
	},
	
//////////////////////////////////////////////
//! Sliders 
//////////////////////////////////////////////

	sliderShow:function(slider) {
		$(slider).animate({
			'opacity': 1
		}, 800);
	},
	
	sliderReset:function(slider){
		
		$(slider).slick('slickGoTo', 0, true);
		app.sliderShow(slider);
	},
	
	sliderReslick:function(slider, minWidth, settinngs) {//TYPO IS REQUIRED...(no idea why)
		if ($(window).width() >= minWidth ) {
			if (!$(slider).hasClass('slick-initialized')) {
				$(slider).slick(settings);
				app.sliderReset(slider);
			}
		}
	},

//--------------------------------------------
//! - Quote Slider
//--------------------------------------------

	sliderQuotes:function(){
		
		settings = {
			'slidesToShow': 1,
			'vertical': false,
			'arrows': false,
			'fade': true,
			'autoplay': true,
			'autoplaySpeed': app.settings.quotsSpeed
		};
		
		//Start the gallery
		$('#js-quote-slider').slick(settings);
		app.sliderShow('#js-quote-slider');
	},

//--------------------------------------------
//! - Image Gallery
//--------------------------------------------

	sliderImageGallery:function(){
		
		settings = {
			'nextArrow': '<a class="slider__btn slider__btn--next btn btn--circle"><i class="icon-arrow-right"></i></a>',
			'prevArrow': '<a class="slider__btn slider__btn--prev btn btn--circle"><i class="icon-arrow-left"></i></a>',
			'fade': true,
			"speed": 600,
			'responsive': [
				{
					'breakpoint': 767,
					'settings': 'unslick',
					'fade': false,
				}
			]
		};
		
		
		//Build the gallery (so the images are only loaded by visiters to the page.
			for (i = 0; i < data.gallery.length ; i++ ){
				$('#js-gallery-slider').append(
					'<div class="slider__slide" style="opacity:0;background-image:url('+ data.gallery[i].src +');"><img src="'+data.gallery[i].mobile_src+'" alt="'+data.gallery[i].src.alt+'" /></div>'
				);
			}

		
		
		//Start the gallery

		$('#js-gallery-slider').slick(settings);
		app.sliderShow('#js-gallery-slider');
		
		
	},

//--------------------------------------------
//! - Videos Gallery
//--------------------------------------------
	sliderVideoGallery:function(){
		settings = {
			'nextArrow': '<a class="slider__btn slider__btn--next btn btn--circle"><i class="icon-arrow-right"></i></a>',
			'prevArrow': '<a class="slider__btn slider__btn--prev btn btn--circle"><i class="icon-arrow-left"></i></a>',
			'slidesToShow': 3,
			'slidesToScroll': 3,
			'responsive': [
				{
					'breakpoint': 767,
					'settings': 'unslick'
				}
			]
		};

		//Apply the link bindings (should be done in app.domevents() but would require refreshing the dom events)
		$('.js-video').click(function(e){ e.preventDefault();
			ytPlayer.show($(this).attr('data-ytid'));
		});
		
		//Start the gallery
		$('#js-video-slider').slick(settings);

		app.sliderShow('#js-video-slider');
		
		
		
	},
	

	
};

//DOC READY and window listeners
if (window.canLoad) { //Check Browser is allowed version
	window.onload = app.init;
}


$(window).resize(function() {
	app.resizeEvents();
});

window.onfocus =function() {
	app.focusEvents();
};

window.onblur = function() {
	app.blurEvents();
};
